/**
 * Get slug part out of contentful handle
 */
export const getCollectionAnchor = ({
  handle,
  fallback,
}: {
  handle?: string;
  fallback: string;
}): string => {
  const parts = handle?.split('/');

  return parts?.[parts.length - 1] || fallback;
};
